import { apiClient } from "../api/apiClient";
import {
  ApiResponse,
  NewsletterResponse,
  NewsletterRequest
} from "../interfaces/ApiResponse";

export const newsletterService = {

  // ================================
  // GET ALL
  // ================================
 getAll: async (): Promise<NewsletterResponse[]> => {

  const response = await apiClient.get<
    ApiResponse<NewsletterResponse[]>
  >("/Newsletter/GetAll");

  const result = response.data;

  console.log("Newsletter API:", result);

  if (!result.isSuccess) {
    throw new Error(result.message);
  }

  // ✅ IMPORTANT FIX HERE
  return result.data || [];
},

  // ================================
  // CREATE
  // ================================
  create: async (payload: NewsletterRequest) => {

    const response = await apiClient.post<
      ApiResponse<NewsletterResponse>
    >("/Newsletter/Create", payload);

    const result = response.data;

    if (!result.isSuccess) {
      throw new Error(result.message);
    }

    return result;
  },

  // ================================
  // TOGGLE STATUS
  // ================================
  toggleStatus: async (subscriberID: number) => {

    const response = await apiClient.put(
      `/Newsletter/toggle-status/${subscriberID}`
    );

    return response.data;
  },

  // ================================
  // DELETE
  // ================================
  delete: async (subscriberID: number) => {

    const response = await apiClient.delete(
      `/Newsletter/Delete/${subscriberID}`
    );

    return response.data;
  }
};